import { useCallback, useState } from "react";

// use this strictly if the api return response.data only
export const useFetchData = (api) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(
        async (params = {}) => {
            try {
                setLoading(true);
                setError(null);

                const response = await api(params);

                setData(response.data);
                return response;
            } catch (err) {
                setError(err);
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [api]
    );

    return {
        data,
        loading,
        error,
        fetchData,
    };
};
